import { ISelect, ISelectItem } from 'app/store/models/select.model';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MessageService } from 'app/store/services/message.service';
import { ETotalCountItem } from 'app/store/models/message.model';
import { SessionService } from 'app/store/services/session.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IUserSessionData, UserType } from 'app/store/models/user.model';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-total-count',
  templateUrl: './total-count.component.html',
  styleUrls: ['./total-count.component.scss'],
})
export class TotalCountComponent implements OnInit, OnDestroy {
  @Input() showInboxStatus: boolean;

  iconCircle = faCircle;

  totalSentToday: number;

  sendLimit: number;

  targetCount: number;

  showType;

  userData: IUserSessionData;

  activeItem: ETotalCountItem = ETotalCountItem.ALL;

  showAll: boolean;

  selectProperties: ISelect<any> = {
    defaultValue: ETotalCountItem.ALL,
    label: 'Select...',
    items: [
      {
        label: 'Total',
        value: ETotalCountItem.ALL,
      },
      {
        label: '7 Days',
        value: ETotalCountItem.SEVEN_DAYS,
      },
      {
        label: '30 Days',
        value: ETotalCountItem.ONE_MONTH,
      },
      {
        label: '6 Months',
        value: ETotalCountItem.SIX_MONTHS,
      },
      {
        label: '1 Year',
        value: ETotalCountItem.ONE_YEAR,
      },
    ],
  };

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private messagesService: MessageService,
    private sessionService: SessionService
  ) {}

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe((sessionData: IUserSessionData) => {
        if (
          [UserType.MASTER, UserType.PARTNER, UserType.VSM].indexOf(
            sessionData.user_type
          ) === -1
        ) {
          this.showType = 'total';
          this.totalSentToday = sessionData.sent_today;
          this.sendLimit = sessionData.send_limit;
          this.updateCount();
        }

        this.userData = sessionData;
      });
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  updateCount(filter: ETotalCountItem = ETotalCountItem.ALL) {
    this.messagesService.getTotalMessagesCount(filter).subscribe(result => {
      this.targetCount = result.total_sent;
    });
  }

  onSelection(value) {
    this.targetCount = undefined;
    this.updateCount(value);
  }

  selectItem(item: ISelectItem) {
    if (!this.showAll) {
      this.showAll = true;
      return;
    }

    this.targetCount = undefined;
    this.updateCount(item.value);
    this.activeItem = item.value;
    this.showAll = false;
  }
}
